var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-menu',{attrs:{"left":"","offset-y":"","offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("activator",null,null,{ on, attrs })]}}],null,true)},[_c('v-card',[_c('v-img',{attrs:{"width":_vm.$vuetify.breakpoint.smAndUp ? '300px' : '100vw',"src":_vm.svgData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }